import {Injectable} from "@angular/core";
import {Camera, CameraResultType, CameraSource} from "@capacitor/camera";
import {DialogService} from "./dialog.service";
import {ToastService} from "./toast.service";

@Injectable()
export class CameraService {
  constructor(
    private readonly dialogs: DialogService,
    private readonly toast: ToastService
  ) {
    // nothing
  }

  getImage(message: string = "How would you like to provide your image?"): Promise<string> {
    return new Promise((resolve, reject) => {
      const doCamera = () => {
        Camera.getPhoto({
          quality: 90,
          height: 1024,
          width: 1024,
          allowEditing: false,
          resultType: CameraResultType.DataUrl,
          source: CameraSource.Camera
        }).then((photo) => {
          resolve(photo.dataUrl);
        });
      };
      const doGallery = () => {
        Camera.getPhoto({
          quality: 90,
          height: 1024,
          width: 1024,
          allowEditing: false,
          resultType: CameraResultType.DataUrl,
          source: CameraSource.Photos
        }).then((photo) => {
          resolve(photo.dataUrl);
        });
      };
      const doChoice = () => {
        this.dialogs.choose({
          message: message,
          buttons: ["Gallery", "Camera"]
        }).then((result) => {
          if (result === 1) {
            doCamera();
          } else if (result === 0) {
            doGallery();
          }
        });
      };

      Camera.requestPermissions({
        permissions: ['camera', 'photos']
      }).then((permissionStatus) => {
        if (permissionStatus.camera !== 'denied' && permissionStatus.photos !== 'denied') {
          doChoice();
        } else if (permissionStatus.camera !== 'denied') {
          doCamera();
        } else if (permissionStatus.photos !== 'denied') {
          doGallery();
        } else {
          this.toast.toastError({
            header: "Missing camera permission",
            message: "We were unable to access your camera. Please check your permissions."
          });
        }
      }).catch(error => {
        doGallery();
      });
    });
  }
}
